import { Schema as S } from "effect";

const DataItemSchema = S.Struct({
  _id: S.String,
  lastEditedDate: S.optional(S.String),
  start: S.String,
  end: S.String,
  duration: S.optional(S.Number),
  plannedDuration: S.optional(S.Number),
  calendar: S.String,
  type: S.optional(S.String),
  adhoc: S.optional(S.Boolean),
  patient: S.optional(S.String),
  scheduled: S.optional(S.Number),
  allDay: S.optional(S.Boolean),
  severity: S.optional(S.String),
  urgency: S.optional(S.Number),
  userDescr: S.optional(S.String),
  resource: S.optional(S.String),
  resourceBased: S.optional(S.Boolean),
  linkByResource: S.optional(S.String),
  title: S.optional(S.String),
  scheduletype: S.optional(S.String),
  employee: S.optional(S.String),
  arrivalTime: S.optional(S.String),
  creationDate: S.optional(S.String),
  isReadOnly: S.optional(S.Boolean),
  wasInTreatment: S.optional(S.Boolean),
  weekdays: S.optional(S.Array(S.Unknown)),
});

// The SDK client unwraps the vendor `{ meta, data }` envelope and raises
// `meta.errors` as exceptions, so this schema describes the payload (`data`).
export const DeleteScheduleResponseSchema = S.Array(DataItemSchema);

export type DeleteScheduleResponse = S.Schema.Type<typeof DeleteScheduleResponseSchema>;
